/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      NO_HIRED_PRODUCTS_TO_BUY: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Ver tarifas móviles',
              link: URLS.MOBILE_TARIFF_LIST,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Para añadir los 20 GB ultrarrápidos necesitas una línea móvil de Movistar',
          msg: [
            'Actualmente no tienes contratada ninguna línea móvil con Movistar, da de alta una nueva o tráete una de otro operador y aprovecha nuestras ofertas.',
          ],
          errorName: 'cliente sin tarifas moviles',
        },
      },
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Número máximo de bonos activado',
          msg: ['Has alcanzado el máximo de bonos activable sobre esta línea'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
